import { request } from '@/shared/api/request'

export const getAgreement = (externalId) => {
	return request({ url: `colcontract/industryAgreement/get/${externalId}`, method: 'GET' })
}
